module.exports = __webpack_public_path__ + "media/scene_12.3974b655.mp3";